import { render } from "./HowWeCurate.vue?vue&type=template&id=151575e6&scoped=true"
import script from "./HowWeCurate.vue?vue&type=script&lang=js"
export * from "./HowWeCurate.vue?vue&type=script&lang=js"

import "./HowWeCurate.vue?vue&type=style&index=0&id=151575e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151575e6"]])

export default __exports__